import { generateGUID } from "@/utils/guid";
import { createItemSettings } from "./createItemSettings";
import { FormItem } from "../types";

export const createFormItem = (type:string):FormItem<any> => {
	return {
		id: `${generateGUID()}`,
		type,
		name: "",
		hideName:false,
		optional:false,
		settings: createItemSettings(type),
		comment:"",
		platforms:[],
	}
};